import { v4 as uuidv4 } from 'uuid'
import { Order } from '@/utils/sorting'
import { TableHeadCellPropsType } from '@/state/ui/global/models'

import { BetDetailsType } from '@/state/common'
import { TableGenericComponent } from '@/views/components'
import { BetDetailsTableRowComponent } from './row.component'

type Props = {
  sortedRows: BetDetailsType[]
  createSortHandler: (
    property: keyof BetDetailsType,
  ) => (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  order: Order
  orderBy: keyof BetDetailsType
  headCells: TableHeadCellPropsType<BetDetailsType>[]
}

export const BetDetailsTableComponent = ({
  sortedRows,
  createSortHandler,
  order,
  orderBy,
  headCells,
}: Props) => {
  const body = sortedRows.map((row: BetDetailsType) => {
    return <BetDetailsTableRowComponent key={uuidv4()} row={row} />
  })

  return (
    <TableGenericComponent<BetDetailsType>
      order={order}
      orderBy={orderBy}
      headCells={headCells}
      rowLength={sortedRows.length}
      isLoading={false}
      body={body}
      hasAction={false}
      createSortHandler={createSortHandler}
    />
  )
}
